import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import CustomDatePicker from '../../components/CustomDatePicker';
import ViewReverse from '../../components/ViewReverse';
import { Dropdown } from '../../components';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import ViewItems from '../../components/ViewItems';
import { rowReverseStyle, rowReverseStylemd } from '../../utils/styles';
import { Dialog, DialogContent } from '@mui/material';
import Divider from '../../components/Divider';
import transactionFunctional from './index.function';
import Button from '../../components/Button';
import ConfirmModal from '../../components/ConfirmModal';
import { TransactionView } from './components';
import dayjs from 'dayjs';
import { cn } from '../../utils/utils';
import LoaderModal from '../../components/LoaderModal';
import { transactionTabs } from '../../config/config';

const Transactions = () => {
  const {
    TextWeight,
    isArabic,
    isModalOpen,
    transactions,
    selectedType,
    fund_loading,
    setSelectedType,
    setIsModalOpen,
    getContentKey,
    setStartDate,
    setEndDate,
    handleGetTransactions,
    isCancelModal,
    toogleCancelModal,
    setSelectedTransaction,
    handleCancelTransaction,
    direction,
    handleDownlaodFundTransDocument,
    fund_document_loading,
    selectedTab,
    onPressTab,
    endDate,
    search_types,
    startDate,
    onPressReset
  } = transactionFunctional();

  return (
    <div>
      <ViewReverse className={'mb-3 sm:mb-5 justify-between items-center'}>
        <Text
          text={getContentKey('heading')}
          size={fontSizes.h24}
          weight={TextWeight.bold}
          color='text-black'
        />

        <ViewReverse className='gap-3'>
          {transactionTabs.map((item) => {
            const isSelected = selectedTab?.id === item.id;
            return (
              <div
                key={item.id}
                onClick={() => onPressTab(item)}
                className={cn(
                  'px-6 py-2 rounded-md transition-colors duration-200 text-center cursor-pointer',
                  isSelected ? 'bg-primary/10' : ' bg-silver-bg '
                )}
              >
                <Text
                  text={getContentKey(item.label)}
                  size={fontSizes.h14}
                  color={isSelected ? 'text-primary' : 'text-silver-text'}
                />
              </div>
            );
          })}
        </ViewReverse>
      </ViewReverse>

      {selectedTab?.id === 1 ? (
        transactions?.transactions?.length > 0 ? (
          <div
            dir={direction}
            className='grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-6 items-start'
          >
            {transactions?.transactions?.map((item, index) => (
              <TransactionView
                item={item}
                getContent={getContentKey}
                key={index}
                onClick={() =>
                  handleDownlaodFundTransDocument(item?.internalId)
                }
              />
            ))}
          </div>
        ) : (
          <Text
            text={getContentKey('no_transactions_found')}
            size={fontSizes.h16}
            isCenter
            className={'mt-10'}
          />
        )
      ) : (
        <>
          <ViewItems
            className={
              'w-full gap-4 border border-grey rounded-xl py-6 px-5 shadow mt-8'
            }
          >
            <ViewReverse
              className={cn(
                'gap-4 flex-col w-full',
                rowReverseStylemd(isArabic)
              )}
            >
              <CustomDatePicker
                label={getContentKey('from')}
                onChange={(date) => setStartDate(date?.$d)}
                width='w-full'
                selectedDate={startDate}
                placeholder={'mm/dd/yyyy'}
                maxDate={dayjs()}
              />
              <CustomDatePicker
                label={getContentKey('to')}
                onChange={(date) => setEndDate(date?.$d)}
                width='w-full'
                placeholder={'mm/dd/yyyy'}
                maxDate={dayjs()}
                selectedDate={endDate}
                minDate={startDate ? dayjs(startDate) : null}
              />
            </ViewReverse>
            <ViewReverse className={`gap-4 w-full`}>
              <Dropdown
                label={getContentKey('search_by_type')}
                selectedValue={selectedType}
                options={transactions?.transactionTypes}
                // isRequired
                valueKey={'title'}
                onSelect={(val) => setSelectedType(val)}
                width='w-full'
              />
              <div className='hidden md:w-full' />
            </ViewReverse>
            <Divider margin='my-1' />
            <ViewReverse className={'gap-4'}>
              <Button
                text={getContentKey('search')}
                onClick={handleGetTransactions}
                className={'py-3 h-10 w-44'}
              />
              <Button
                text={getContentKey('reset')}
                bgColor='bg-transparent'
                color='text-primary'
                onClick={() => onPressReset()}
                className={'py-3 h-10 w-44 border border-primary'}
              />
            </ViewReverse>
          </ViewItems>

          {transactions?.transactions?.length > 0 ? (
            <div
              dir={direction}
              className='grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-6 items-start'
            >
              {transactions?.transactions?.map((item, index) => (
                <TransactionView
                  item={item}
                  getContent={getContentKey}
                  key={index}
                  onClick={() =>
                    handleDownlaodFundTransDocument(item?.internalId)
                  }
                />
              ))}
            </div>
          ) : (
            <Text
              text={getContentKey('no_transactions_found')}
              size={fontSizes.h16}
              isCenter
              className={'mt-10'}
            />
          )}
        </>
      )}

      {/* <CustomTable
                heading={getContentKey('transaction_list')}
                isOpen
                headCells={isArabic ? transactionsColumns(getContentKey)?.reverse() : transactionsColumns(getContentKey)}
                data={transactions}
                onPress={(row) => {
                    setSelectedTransaction(row);
                    toogleCancelModal();
                }}
            /> */}

      <Dialog open={isModalOpen} fullWidth>
        <DialogContent>
          <ViewReverse className={'justify-between'}>
            <ViewReverse
              className={`sm:items-end sm:gap-2 flex-col sm:${rowReverseStyle(
                isArabic
              )}`}
            >
              <Text
                text='Transactions'
                color='text-dark-blue'
                size={fontSizes.h24}
                weight={TextWeight.bold}
              />
              <Text
                text='8000866041 Transaction Details'
                color='text-dark-blue'
                size={fontSizes.h14}
                className={'mb-[5px]'}
              />
            </ViewReverse>
            <ReactSVG
              src={icons.modalCross}
              className='opacity-50 cursor-pointer'
              onClick={() => setIsModalOpen(false)}
            />
          </ViewReverse>

          <ViewReverse
            className={
              'mt-1 justify-between items-center border border-grey bg-grey bg-opacity-30 px-4 py-3 rounded'
            }
          >
            <ViewReverse className={'gap-4'}>
              <ViewItems className={'gap-2'}>
                <Text text='1020' color='text-dark-blue' size={fontSizes.h14} />
                <Text
                  text='Al-Jazira Bank'
                  color='text-light-blue'
                  size={fontSizes.h14}
                />
              </ViewItems>
              <ViewItems className={'gap-2'}>
                <Text
                  text='Queued'
                  color='text-dark-blue'
                  size={fontSizes.h14}
                />
                <Text
                  text='Limit order'
                  color='text-light-blue'
                  size={fontSizes.h14}
                />
              </ViewItems>
            </ViewReverse>

            <ViewReverse className={'items-center gap-4'}>
              <ReactSVG src={icons.roundArrow} />
              <ReactSVG src={icons.modalCross} />
              <ReactSVG src={icons.edit} />
            </ViewReverse>
          </ViewReverse>

          <ViewItems className={'mt-4 border border-grey rounded px-4 py-3'}>
            <Text
              text='Cancelled or rejected transactions'
              color='text-primary-light'
              size={fontSizes.h14}
            />

            <ViewReverse
              className={`w-full mt-2 mb-3 gap-4 flex-col sm:${rowReverseStyle(
                isArabic
              )}`}
            >
              <div className='w-full sm:w-1/2'>
                <ViewReverse className={'justify-between'}>
                  <Text text='Remaining quantity' size={fontSizes.h14} />
                  <Text text='12' color='text-dark-blue' size={fontSizes.h14} />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Average ex. Price' size={fontSizes.h14} />
                  <Text
                    text='0.0000'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Executed fees' size={fontSizes.h14} />
                  <Text
                    text='0.00'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Last executed time' size={fontSizes.h14} />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />
              </div>

              <div className='w-full sm:w-1/2'>
                <ViewReverse className={'justify-between'}>
                  <Text text='Executed quantity' size={fontSizes.h14} />
                  <Text text='0' color='text-dark-blue' size={fontSizes.h14} />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Executed amount' size={fontSizes.h14} />
                  <Text
                    text='0.00'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Total executed amount' size={fontSizes.h14} />
                  <Text
                    text='0.00'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Market respond' size={fontSizes.h14} />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />
              </div>
            </ViewReverse>
          </ViewItems>

          <ViewItems className={'mt-4 border border-grey rounded px-4 py-3'}>
            <Text
              text='Cancelled/Rejected transactions'
              color='text-primary-light'
              size={fontSizes.h14}
            />

            <ViewReverse
              className={`w-full mt-2 mb-3 gap-4 flex-col sm:${rowReverseStyle(
                isArabic
              )}`}
            >
              <div className='w-full sm:w-1/2'>
                <ViewReverse className={'justify-between'}>
                  <Text text='Portfolio' size={fontSizes.h14} />
                  <Text
                    text='1-TADAWUL1'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Fill term' size={fontSizes.h14} />
                  <Text
                    text='Market default'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Order date' size={fontSizes.h14} />
                  <Text
                    text='14/09/2020'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Disclosed volume' size={fontSizes.h14} />
                  <Text text='0' color='text-dark-blue' size={fontSizes.h14} />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Fees amount' size={fontSizes.h14} />
                  <Text
                    text='0.20'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />
              </div>

              <div className='w-full sm:w-1/2'>
                <ViewReverse className={'justify-between'}>
                  <Text text='Cash account' size={fontSizes.h14} />
                  <Text
                    text='78110000167'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Min quantity' size={fontSizes.h14} />
                  <Text text='0' color='text-dark-blue' size={fontSizes.h14} />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Expiry date' size={fontSizes.h14} />
                  <Text
                    text='14/09/2020'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-between mb-1'}>
                  <Text text='Order amount' size={fontSizes.h14} />
                  <Text
                    text='198.00'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />

                <ViewReverse className={'justify-end mb-1'}>
                  <Text
                    text='198.00'
                    color='text-dark-blue'
                    size={fontSizes.h14}
                  />
                </ViewReverse>
                <Divider className='mt-1 mb-2 bg-grey' />
              </div>
            </ViewReverse>
          </ViewItems>
        </DialogContent>
      </Dialog>

      <ConfirmModal
        open={isCancelModal}
        title={getContentKey('cancel_transaction')}
        description={getContentKey('cancel_confirmation')}
        onClose={toogleCancelModal}
        onConfirm={handleCancelTransaction}
      />

      <LoaderModal open={fund_document_loading || fund_loading} />
    </div>
  );
};

export default Transactions;
